import { combineReducers } from 'redux';

import managedUsers from './managedUsers.reducer';
import id from './user.id.reducer';
import leadAssigment from './user.lead.assigment.reducer';
import licenses from './user.license.reducer';
import roles from './user.role.reducer';
import userProperties from './user.system.properties.reducer';
import telephony from './user.telephony.reducer';
import userPropertiesManagement from './user.user.properties.reducer';
import users from './users.reducer';

const reducer = {
  users,
  managedUsers,
  user: combineReducers({
    licenses,
    roles,
    id,
    leadAssigment,
    telephony,
    userProperties,
    userPropertiesManagement,
  }),
};

export default reducer;
